import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-influencer-auth',
  templateUrl: './influencer-auth.component.html',
  styleUrls: ['./influencer-auth.component.scss']
})
export class InfluencerAuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/influencer-auth/influencer-auth.component.ts